<div class="page">
  <div class="page-main">
    <app-header></app-header>

    <router-outlet></router-outlet>
  </div>
</div>
